// Domyślna nazwa urządzenia na liście w panelu rodzica („Tablet z Androidem”, „iPad”…), żeby rodzic nie musiał jej wymyślać przy logowaniu.
// Rodzic może ją zmienić; nazwa służy tylko do rozpoznania urządzenia na liście.

/** `touchPoints`: navigator.maxTouchPoints — iPadOS udaje komputer Mac, ale ma ekran dotykowy. */
export function guessDeviceName(userAgent: string, touchPoints = 0): string {
  const ua = userAgent;
  if (/iPad/i.test(ua) || (/Macintosh/i.test(ua) && touchPoints > 1)) return 'iPad';
  if (/iPhone|iPod/i.test(ua)) return 'iPhone';
  if (/Android/i.test(ua)) return /Mobile/i.test(ua) ? 'Telefon z Androidem' : 'Tablet z Androidem';
  if (/Windows|Macintosh|Linux|CrOS/i.test(ua)) return 'Komputer';
  return 'Urządzenie';
}
